import { render, staticRenderFns } from "./FormResponseBlock.vue?vue&type=template&id=49a68526&scoped=true"
import script from "./FormResponseBlock.vue?vue&type=script&lang=js"
export * from "./FormResponseBlock.vue?vue&type=script&lang=js"
import style0 from "./FormResponseBlock.vue?vue&type=style&index=0&id=49a68526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a68526",
  null
  
)

export default component.exports